import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { resetCredentials as resetCredentialsConnect } from '../../../../../../stores/credentials-store';
import { Header, HeaderProps } from '../../../../../organisms/Header/Header';
import { stopPollingCredentials as stopPollingCredentialsImport } from '../../../../../../connectivity/services/credentials';
import { setApplicationError as setApplicationErrorConnect } from '../../../../../../stores/app-state-store';
import { PageView } from '../../../../../../models/analytics';

export type AwaitingScreenHeaderProps = HeaderProps & { allowExit?: boolean };

export type AwaitingScreenHeaderPresenterProps = AwaitingScreenHeaderProps & {
  pageView: PageView;
  stopPollingCredentials?: () => void;
} & ReduxProps;

export const AwaitingScreenHeaderPresenter: React.FC<AwaitingScreenHeaderPresenterProps> = ({
  onBack,
  pageView,
  addBottomMargin,
  resetCredentials,
  allowExit = false,
  stopPollingCredentials = stopPollingCredentialsImport,
}) => {
  const onBackWithAnalytics: VoidFunction = () => {
    resetCredentials();
    stopPollingCredentials();
  };
  const onBackFallback = allowExit ? onBackWithAnalytics : undefined;

  return (
    <div data-testid="awaiting-screens-header">
      <Header
        pageView={pageView}
        onBack={onBack || onBackFallback}
        addBottomMargin={addBottomMargin}
      />
    </div>
  );
};

const mapDispatchToProps = {
  resetCredentials: resetCredentialsConnect,
  setApplicationError: setApplicationErrorConnect,
};
const connector = connect(null, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export const AwaitingScreenHeader = connector(AwaitingScreenHeaderPresenter);
